// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Pārvietots ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accCommandKey: () => 'Komanda',
  accControlKey: () => 'Aizvērt',
  accPositionAfter: () => 'pēc',
  accPositionBefore: () => 'pirms',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Nospiediet un turiet taustiņu ' +
    p['keyPressed'] +
    ' un Shift, pēc tam izmantojiet bulttaustiņus, lai pārkārtotu.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Ievadiet pilnu datumu šādi: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Ievadiet mēnesi un gadu šādi: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grupa',
  chart_labelSeries: () => 'Sērija',
  chart_labelValue: () => 'Vērtība',
  checkboxSet_requiredMessageDetail: () => 'Nepieciešams',
  checkbox_requiredMessageDetail: () => 'Nepieciešams',
  close: () => 'Aizvērt',
  collection_noData: () => 'Nav parādāmu datu.',
  collection_selectAllRows: () => 'Atlasīt visas rindas',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Atlasīt rindu ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Nav kārtojams',
  collection_sortEnabled: () => 'Kārtojams',
  confirmation: () => 'Apstiprinājums',
  datePicker_currentDate: () => 'Pašreizējais datums',
  datePicker_goToToday: () => 'Uz šodienu',
  datePicker_label: () => 'Datuma atlasītājs',
  datePicker_month: () => 'Mēnesis',
  datePicker_months: () => 'Mēneši',
  datePicker_next: () => 'Tālāk',
  datePicker_nextDecade: () => 'Nākamā dekāde',
  datePicker_nextMonth: () => 'Nākamais mēnesis',
  datePicker_prev: () => 'Atpakaļ',
  datePicker_prevDecade: () => 'Iepriekšējā dekāde',
  datePicker_prevMonth: () => 'Iepriekšējais mēnesis',
  datePicker_restricted: () => 'Ierobežots',
  datePicker_selected: () => 'Atlasīts',
  datePicker_today: () => 'Šodien',
  datePicker_weekNum: (p: { NUM: string }) => p['NUM'] + '. nedēļa',
  datePicker_weekNumColLabel: () => 'Nedēļas numurs',
  datePicker_year: () => 'Gads',
  datePicker_years: () => 'Gadi',
  error: () => 'Kļūda',
  expandableList_expandCollapseInstructionText: () =>
    'Izmantojiet bulttaustiņus, lai izvērstu un sakļautu',
  expandableList_groupCollapse: () => 'Sakļauts',
  expandableList_groupExpand: () => 'Izvērsts',
  filePicker_addFiles: () => 'Pievienot failus',
  filePicker_dropzonePrimaryText: () => 'Velciet un nometiet',
  filePicker_dropzoneSecondaryText: () => 'Atlasiet failu vai nometiet to šeit',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Atlasiet vai nometiet šeit failus',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nevar augšupielādēt failus ar tipu: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Augšupielādējiet pa vienam failam',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nevar augšupielādēt failus ar tipu ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'nezināms',
  formControl_clear: () => 'Notīrīt',
  formControl_day: () => 'Diena',
  formControl_helpAvailable: () => 'Palīdzība pieejama',
  formControl_hide: () => 'Paslēpt',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Ir sasniegts ' +
    ((
      {
        zero: new Intl.NumberFormat('lv').format(p['CHARACTER_LIMIT']) + ' rakstzīmju',
        one: new Intl.NumberFormat('lv').format(p['CHARACTER_LIMIT']) + ' rakstzīmes'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('lv').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('lv').format(p['CHARACTER_LIMIT']) + ' rakstzīmju') +
    ' ierobežojums.',
  formControl_loading: () => 'Ielādē',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Var ievadīt ne vairāk kā ' + p['MAX_LENGTH'] + ' rakstzīmes.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Atlikušas ' + p['CHARACTER_COUNT'] + ' rakstzīmes.',
  formControl_month: () => 'Mēnesis',
  formControl_readOnly: () => 'Tikai lasāms',
  formControl_requiredMessageDetail: () => 'Ievadiet vērtību.',
  formControl_show: () => 'Rādīt',
  formControl_year: () => 'Gads',
  gantt_labelDate: () => 'Datums',
  gantt_labelEnd: () => 'Beigt',
  gantt_labelLabel: () => 'Etiķete',
  gantt_labelRow: () => 'Rinda',
  gantt_labelStart: () => 'Sākt',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nav atrasta neviema atbilstoša sadaļa.',
  indexer_keyboardInstructionText: () => 'Nospiediet Enter, lai atlasītu vērtību.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Starp ' + p['FROM_SECTION'] + ' un ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Divreiz pieskarieties un turiet, lai ieietu žestu režīmā, tad velciet uz augšu vai uz leju, lai pielāgotu vērtību.',
  info: () => 'Informācija',
  inputDateMask_date_cleared: () => 'Dzēšanas datums',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tukšs',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'gggg',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Ievadiet datumu, kas ir ' + p['max'] + ' vai agrāk.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Ievadiet datumu, kas ir ' + p['min'] + ' vai vēlāk.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Ievadiet pieejamu datumu.',
  inputDatePicker_instruction: () => 'Nospiediet Tab, lai piekļūtu kalendāram.',
  inputDatePicker_selectDate: () => 'Atlasīt datumu',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Ievadiet mēnesi un gadu, kas ir ' + p['max'] + ' vai pirms tam.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Ievadiet mēnesi un gadu, kas ir ' + p['min'] + ' vai pēc tam tam.',
  inputNumber_converterParseError: () => 'Ievadīt skaitli.',
  inputNumber_decrease: () => 'Samazināt',
  inputNumber_increase: () => 'Palielināt',
  inputPassword_hidden: () => 'Parole paslēpta',
  inputPassword_hide: () => 'Paslēpt paroli',
  inputPassword_show: () => 'Rādīt paroli',
  inputSensitiveText_hidden: () => 'Slepenais teksts ir paslēpts',
  list_msgFetchCompleted: () => 'Ielādēts',
  list_msgFetchingData: () => 'Ielādē',
  list_suggestion: () => 'Priekšlikums',
  messageToast_allMessagesClosed: () => 'Visi uznirstošie ziņojumi ir aizvērti.',
  message_close: () => 'Aizvērt',
  message_confirmation: () => 'Veiksmīgi',
  message_error: () => 'Kļūda',
  message_info: () => 'Informācija',
  message_navigationFromMessagesRegion: () =>
    'Notiek ieeja ziņojumu apgabalā. Nospiediet F6, lai naviģētu atpakaļ uz iepriekšējo fokusēto elementu.',
  message_navigationToMessagesRegion: () =>
    'Ziņojumu apgabalā ir jauni ziņojumi. Nospiediet F6, lai naviģētu uz visnesenāko ziņojumu apgabalu.',
  message_warning: () => 'Brīdinājums',
  noData_message: () => 'Nav vienumu, ko parādīt',
  overflowItemLabel: () => 'Papildu cilnes',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Pašlaik notiek',
  radio_helpForRadio: () => 'Radiopogas palīdzība',
  radio_requiredMessageDetail: () => 'Atlasiet vērtību.',
  selectMultiple_apply: () => 'Lietot',
  selectMultiple_back: () => 'Atpakaļ',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Izmantojiet pa labi un pa kreisi vērsto bultiņu taustiņus, lai iezīmētu atlasītās vērtības.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Nospiediet atpakaļatkāpes taustiņu vai Delete, lai noņemtu atlasīto vērtību.',
  selectMultiple_selectedValues: () => 'Atlasītās vērtības',
  selectMultiple_showSelectedValues: () => 'Rādīt tikai atlasītās vērtības.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Atlasītas ' + p['VALUE_COUNT'] + ' vērtības.',
  select_addToList: () => 'Pievienot sarakstam',
  select_addToListAvailable: () => 'Pievienot pieejamam sarakstam',
  select_moreSearchOptions: () => 'Vairāk meklēšanas opciju',
  select_moreSearchOptionsAvailable: () => 'Pieejamas papildu meklēšanas opcijas',
  select_noMatchesFound: () => 'Nav atrasta neviena atbilstība.',
  select_oneMatchFound: () => 'Atrasta viena atbilstība',
  select_requiredMessageDetail: () => 'Atlasiet vērtību.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Atrastas ' + p['TOTAL_SIZE'] + ' atbilstības',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Atrastas ' + p['TOTAL_SIZE'] + ' vai vairāk atbilstību',
  selectorAll_deselectAll: () => 'Noņemt visa atlasi',
  selectorAll_selectAll: () => 'Atlasīt visu',
  selector_selected: () => 'Izvēles rūtiņa ir atlasīta',
  selector_unselected: () => 'Izvēles rūtiņa nav atlasīta',
  tabBarNavigationList_removeCueText: () => 'Noņemams',
  timeComponent_tooltipZoomIn: () => 'Tuvināt',
  timeComponent_tooltipZoomOut: () => 'Tālināt',
  train_current: () => 'Pašreizējais',
  train_message_type: () => 'Ziņojuma tips',
  train_not_visited: () => 'Nav apmeklēts',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Darbība ' + p['currentStep'] + ' no ' + p['numberOfSteps'],
  train_visited: () => 'Apmeklēts',
  userAssistance_learnMore: () => 'Uzzināt vairāk',
  userAssistance_required: () => 'Nepieciešams',
  vis_clearSelection: () => 'Notīrīt atlasi',
  vis_drillable: () => 'Detalizējams',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' no ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Slīdošā teksta atlase',
  vis_marqueeZoomTooltip: () => 'Slīdošā teksta tālummaiņa',
  vis_noData: () => 'Nav parādāmu datu',
  vis_panTooltip: () => 'Panoramēt',
  vis_stateLoaded: () => 'Ielādēts',
  vis_stateLoading: () => 'Ielādē',
  vis_stateSelected: () => 'Atlasīts',
  vis_stateUnselected: () => 'Neatlasīts',
  warn: () => 'Brīdinājums'
};
export default bundle;
